import './styles.css';
const container = document.querySelector('.how-to--list');
const handleDots = () => {
    if (container) {
        const dotsContainer = document.getElementById('dotsContainer');
        const pages = Math.round(container.scrollWidth / container.clientWidth);
        dotsContainer.innerHTML = '';
        for (let i = 0; i < pages; i++) {
            const dot = document.createElement('div');
            dot.classList.add('dot');
            dot.addEventListener('click', () => {
                container?.scrollTo({
                    left: i * container.clientWidth,
                    behavior: 'smooth'
                });
                const dots = dotsContainer?.querySelectorAll('.dot');
                dots.forEach((dot) => {
                    dot.classList.remove("active");
                });
                dot.classList.add('active');
            });
            if (i === 0) {
                dot.classList.add('active');
            }
            dotsContainer?.appendChild(dot);
        }
        container.addEventListener('scroll', () => {
            const scrollPosition = container.scrollLeft;
            const currentPage = Math.round(scrollPosition / container.clientWidth);
            const dots = dotsContainer?.querySelectorAll('.dot');
            dots.forEach((dot, index) => {
                if (index === currentPage) {
                    dot.classList.add('active');
                }
                else {
                    dot.classList.remove('active');
                }
            });
        });
    }
};
handleDots();
window.addEventListener('resize', () => {
    handleDots();
});
